import { motion, AnimatePresence } from "framer-motion";
import { Heart } from "lucide-react";

const SaveNotification = ({ show, message }) => {
  if (!show) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className="fixed top-4 left-[calc(48%-8rem)] transform -translate-x-1/2 z-[9999] bg-white border border-gray-200 text-gray-800 px-4 py-2 rounded-lg shadow-lg flex items-center gap-2"
      >
        <Heart className="w-5 h-5 text-red-500 fill-red-500" />
        <span className="text-sm font-medium">{message}</span>
      </motion.div>
    </AnimatePresence>
  );
};

export default SaveNotification; 